import module from './module.js'

// Components
import './components/component.js'
import './components/autorizar/component.js'
import './components/autorizar/launcher/component.js'
import './components/autorizar/lista/component.js'
import './components/configuracion/component.js'
import './components/configuracion/empleado/component.js'
import './components/configuracion/empleado/usuario/component.js'
import './components/configuracion/empleado/vincularusuario/component.js'
import './components/configuracion/empresa/component.js'
import './components/configuracion/empresa/conceptos/component.js'
import './components/configuracion/empresa/conceptos/editar/component.js'
import './components/configuracion/empresa/conceptos/item/component.js'
import './components/configuracion/empresa/diastolerancia/component.js'
import './components/configuracion/empresa/responsables/component.js'
import './components/configuracion/empresa/responsables/agregar/component.js'
import './components/configuracion/empresa/responsables/item/component.js'
import './components/configuracion/launcher/component.js'
import './components/configuracion/proyecto/component.js'
import './components/configuracion/proyecto/colaboradores/component.js'
import './components/configuracion/proyecto/colaboradores/colaborador/component.js'
import './components/configuracion/proyecto/colaboradores/colaborador/cuentacontable/component.js'
import './components/configuracion/proyecto/colaboradores/colaborador/usuario/component.js'
import './components/configuracion/proyecto/colaboradores/colaborador/usuario/desvincular/component.js'
import './components/configuracion/proyecto/diastolerancia/component.js'
import './components/configuracion/proyecto/diastolerancia/editar/component.js'
import './components/configuracion/proyecto/esquema/component.js'
import './components/configuracion/proyecto/esquema/editar/component.js'
import './components/configuracion/proyecto/responsables/component.js'
import './components/configuracion/proyecto/responsables/item/component.js'
import './components/configuracion/proyecto/responsables/item/editar/component.js'
import './components/configuracion/proyecto/responsables/item/editar/confirmar/component.js'
import './components/configuracion/proyecto/responsables/norequeridos/component.js'
import './components/configuracion/proyecto/responsables/requeridos/component.js'
import './components/configuracion/proyecto/responsables/requeridosValidar/component.js'
import './components/configuracion/proyecto/responsables/usuario/component.js'
import './components/configuracion/proyectos/component.js'
import './components/launcher/component.js'

import './components/misviaticos/component.js'
import './components/misviaticos/launcher/component.js'
import './components/misviaticos/lista/component.js'
import './components/misviaticos/solicitar/component.js'

import './components/maquilar/component.js'
import './components/maquilar/launcher/component.js'
import './components/maquilar/lista/component.js'

import './components/pagar/component.js'
import './components/pagar/launcher/component.js'
import './components/pagar/lista/component.js'

import './components/timbrar/component.js'
import './components/timbrar/launcher/component.js'
import './components/timbrar/lista/component.js'

import './components/cerrar/component.js'
import './components/cerrar/launcher/component.js'
import './components/cerrar/lista/component.js'

import './components/todos/component.js'
import './components/todos/launcher/component.js'
import './components/todos/lista/component.js'

import './components/pagos/component.js'
import './components/pagos/launcher/component.js'
import './components/pagos/lista/component.js'
import './components/pagos/pago/configurar/component.js'
import './components/pagos/pago/configurar/colaborador/component.js'
import './components/pagos/pago/configurar/pagadora/component.js'
import './components/pagos/pago/ficha/component.js'
import './components/pagos/pago/item/component.js'
import './components/pagos/pendientes/component.js'
import './components/pagos/realizados/component.js'

import './components/pendientes/component.js'

import './components/shared/anticipos/component.js'
import './components/shared/anticipos/anticipo/component.js'
import './components/shared/anticipos/anticipo/editar/component.js'
import './components/shared/anticipos/anticipo/informacion/component.js'
import './components/shared/anticipos/dialogo/component.js'

import './components/shared/anticipos/solicitud/component.js'
import './components/shared/anticipos/solicitud/editar/component.js'
import './components/shared/anticipos/solicitud/seguimiento/component.js'

import './components/shared/colaborador/component.js'
import './components/shared/colaborador/elegir/component.js'
import './components/shared/colaborador/informacion/component.js'
import './components/shared/comprobantes/component.js'
import './components/shared/comprobantes/agregar/component.js'
import './components/shared/comprobantes/agregar/errores/component.js'
import './components/shared/comprobantes/agregar/errores/item/component.js'
import './components/shared/comprobantes/agregar/formulario/component.js'
import './components/shared/comprobantes/agregar/formulario/pdf/component.js'
import './components/shared/comprobantes/agregar/formulario/xml/component.js'
import './components/shared/comprobantes/agregar/manual/component.js'
import './components/shared/comprobantes/agregar/seleccionar/component.js'
import './components/shared/comprobantes/agregar/validos/component.js'
import './components/shared/comprobantes/agregar/validos/item/component.js'
import './components/shared/comprobantes/item/component.js'

import './components/shared/devoluciones/component.js'
import './components/shared/devoluciones/agregar/component.js'
import './components/shared/devoluciones/agregar/errores/component.js'
import './components/shared/devoluciones/agregar/errores/item/component.js'
import './components/shared/devoluciones/agregar/formulario/component.js'
import './components/shared/devoluciones/agregar/formulario/pdf/component.js'
import './components/shared/devoluciones/agregar/formulario/xml/component.js'
import './components/shared/devoluciones/agregar/formulario/archivo/component.js'
import './components/shared/devoluciones/agregar/manual/component.js'
import './components/shared/devoluciones/agregar/seleccionar/component.js'
import './components/shared/devoluciones/agregar/validos/component.js'
import './components/shared/devoluciones/agregar/validos/item/component.js'
import './components/shared/devoluciones/item/component.js'

import './components/shared/reembolsos/component.js'
import './components/shared/reembolsos/agregar/component.js'
import './components/shared/reembolsos/solicitud/component.js'
import './components/shared/reembolsos/solicitud/seguimiento/component.js'

import './components/shared/resumen/component.js'

import './components/shared/item/component.js'
import './components/shared/item/autorizar/component.js'
import './components/shared/item/cerrar/component.js'
import './components/shared/item/maquilar/component.js'
import './components/shared/item/eliminar/component.js'
import './components/shared/item/eliminarNomina/component.js'
import './components/shared/item/revisar/component.js'
import './components/shared/item/status/component.js'

import './components/shared/reembolso/component.js'
import './components/shared/reembolso/dialogo/component.js'
import './components/shared/reembolso/solicitar/componet.js'
import './components/shared/viaje/component.js'
import './components/shared/viaje/captura/component.js'
import './components/shared/viaje/item/component.js'
import './components/viatico/component.js'
import './components/viatico/seguimiento/component.js'
// Routes
import './routes/viaticos/configuracion/proyecto.js'
import './routes/viaticos/configuracion/proyecto/colaboradores.js'
import './routes/viaticos/configuracion/proyecto/diastolerancia.js'
import './routes/viaticos/configuracion/proyecto/esquema.js'
import './routes/viaticos/configuracion/proyecto/responsables.js'
import './routes/viaticos/configuracion/proyectos.js'
import './routes/viaticos/misviaticos/solicitar.js'
import './routes/viaticos/misviaticos/viatico.js'
import './routes/viaticos/pagos/pendientes.js'
import './routes/viaticos/pagos/realizados.js'

import './routes/viaticos/pendientes.js'
import './routes/viaticos/pendientes/misviaticos.js'
import './routes/viaticos/pendientes/autorizar.js'
import './routes/viaticos/pendientes/maquilar.js'
import './routes/viaticos/pendientes/pagar.js'
import './routes/viaticos/pendientes/timbrar.js'
import './routes/viaticos/pendientes/cerrar.js'
import './routes/viaticos/pendientes/todos.js'

import './routes/viaticos/administrador.js'
import './routes/viaticos/autorizar.js'
import './routes/viaticos/configuracion.js'
import './routes/viaticos/pagos.js'
import './routes/viaticos/viaticos.js'
import './routes/viaticos.js'
// Services
import './services/Colaborador.js'
import './services/Permisos.js'
import './services/Viaticos.js'
import './services/Catalogos/Categoriasvitatico.js'
import './services/Catalogos/Monedas.js'
import './services/Catalogos/Proyecto.js'
import './services/Catalogos/Proyectos.js'
import './services/Catalogos/Usuarios.js'
import './services/Catalogos/Usuariosnovinculados.js'
import './services/Catalogos/Colaborador/CuentasBancarias.js'
import './services/Catalogos/Pagadora/CuentasBancarias.js'
import './services/Catalogos/Proyecto/Colaboradores.js'
import './services/Catalogos/Proyecto/Esquemas.js'
import './services/Colaborador/Cuentacontable.js'
import './services/Colaborador/Usuario.js'
import './services/Proyecto/Diastolerancia.js'
import './services/Proyecto/Responsables.js'
import './services/Proyecto/Responsable.js'
import './services/Proyecto/Esquemas.js'

import './services/Solicitud/Anticipo.js'
import './services/Solicitud/Comprobacion.js'
import './services/Solicitud/Devolucion.js'
import './services/Solicitud/Reembolso.js'

import './services/Usuario/Colaborador.js'
import './services/Usuario/Proyectos.js'
import './services/Usuario/Viaticos.js'
import './services/Viaticos/Autorizacion.js'
import './services/Viaticos/Configuracion.js'

import './services/Viaticos/Maquilar.js'
import './services/Viaticos/Pagar.js'
import './services/Viaticos/Timbrar.js'
import './services/Viaticos/Cerrar.js'
import './services/Viaticos/Todos.js'
import './services/Viaticos/Exportar.js'

import './services/Viaticos/Pagos.js'
import './services/Viaticos/Viatico.js'
import './services/Viaticos/Pagos/Pago.js'
import './services/Viaticos/Pagos/Pendientes.js'
import './services/Viaticos/Pagos/Realizados.js'
import './services/Viaticos/Pagos/Pago/Pagar.js'

import './services/Viaticos/Pendientes.js'

import './services/Viaticos/Viatico/Anticipos.js'
import './services/Viaticos/Viatico/Comprobante.js'
import './services/Viaticos/Viatico/Comprobantes.js'
import './services/Viaticos/Viatico/Devolucion.js'
import './services/Viaticos/Viatico/Devoluciones.js'
import './services/Viaticos/Viatico/Notasventas.js'
import './services/Viaticos/Viatico/Revisar.js'
import './services/Viaticos/Viatico/Segumiento.js'
import './services/Viaticos/Viatico/Solicitud.js'
import './services/Viaticos/Viatico/Solicitudes.js'

import './services/Viaticos/Viatico/Anticipos/Anticipo.js'
import './services/Viaticos/Viatico/Anticipos/Solicitud.js'

import './services/Viaticos/Viatico/Comprobantes/Comprobante.js'
import './services/Viaticos/Viatico/Comprobantes/Documentos/Archivo.js'
import './services/Viaticos/Viatico/Comprobantes/Informacion.js'
import './services/Viaticos/Viatico/Comprobantes/Agregar/Decodificar.js'
import './services/Viaticos/Viatico/Comprobantes/Agregar/Documentos.js'
import './services/Viaticos/Viatico/Comprobantes/Agregar/Existe.js'

import './services/Viaticos/Viatico/Devoluciones/Comprobante.js'
import './services/Viaticos/Viatico/Devoluciones/Documentos/Archivo.js'
import './services/Viaticos/Viatico/Devoluciones/Informacion.js'
import './services/Viaticos/Viatico/Devoluciones/Agregar/Decodificar.js'
import './services/Viaticos/Viatico/Devoluciones/Agregar/Documentos.js'

export default module.name



// WEBPACK FOOTER //
// ./src/viaticos/index.js